import './styles.scss';
import React from 'react';
import SessionDescription from '../SessionDescription';
import { $state, $stateParams } from '../../../../router';
import { GeckoAlert } from '@geckolabs/gecko-react-ui';

const SessionItem = ({session, time, attendance}) => {
    const handler = () => $state.go('rsvp-lite-manage-session', Object.assign({}, $stateParams, {session_id: session.id}));
    return (
        <div 
            className="session-list-item rsvp-lite-card"
            tabIndex={0} 
            role="button"
            onClick={handler}
            onKeyUp={(evt) => evt.type === 'keyup' && evt.key === 'Enter' ? handler() : null}>
                <SessionDescription {...{session, time, attendance}} />
        </div>
    );
};



export const SessionList = ({sessions}) => {
    
    if (sessions.length === 0) {
        return (
            <div className="rsvp-lite-card"> 
                <GeckoAlert type="warning">
                    No sessions found.
                </GeckoAlert>
            </div>
        );
    }

    return (
        <div className="session-list">
            {sessions.map((session, key) => (
                <SessionItem 
                    session={session}
                    attendance={session.attendance}
                    key={key} 
                />
            ))}
        </div>
    );
};

export default SessionList;